import React from 'react'

import { Reorder } from 'framer-motion'

import ImageCard from './ImageCard'
import { PlusIcon } from 'images'


const ImageList = (props) => {
  const { images, setImages, selectedImageId, setSelectedImageId, addCard, onOpenExpandedImage, readonly } = props

  const getStatus = (image) => {
    if (image.media === null && image.headline === '' && image.description === '' && image.url === '') {
      return 'missing'
    } else if (image.media && image.headline && image.description && image.url) {
      return 'ready'
    } else {
      return 'partial'
    }
  }

  // return
  return (
    <div className='image-list-container'>
      {!readonly ? (
        <Reorder.Group 
          values={images} 
          axis='x' className='image-list'
          onReorder={(newOrder) => {
            console.log('newOrder', newOrder)
            setImages(newOrder)
          }}
        >
          {images?.map((image, index) => (
            <Reorder.Item value={image} key={image.id}>
              <ImageCard
                index={index}
                media={image.media}
                status={getStatus(image)}
                isSelected={selectedImageId === image.id}
                handleSelect={() => setSelectedImageId(image.id)}
                handleDoubleClick={() => onOpenExpandedImage?.(image.id)}
              />
            </Reorder.Item>
          ))}
        </Reorder.Group>) 
        : 
        (
          <div className='image-list'>
            {images?.map((image, index) => (
              <ImageCard
                key={image.id}
                index={index}
                media={image.media}
                status={getStatus(image)}
                isSelected={selectedImageId === image.id}
                handleSelect={() => setSelectedImageId(image.id)}
                handleDoubleClick={() => onOpenExpandedImage?.(image.id)}
              />
            ))}
          </div>
        )}

      {images.length < 10 && !readonly && (
        <div className='image-list__add-button' onClick={() => addCard(1)}>
          <PlusIcon width={22} height={22} />
        </div>
      )}
    </div>
  )
}

export default ImageList